module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaLocalidades,
      "search": _vm.search,
      "no-data-text": 'Este projeto não possui localidades.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.nome",
      fn: function(props) {
        return [(_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('div', [_c('router-link', {
          attrs: {
            "to": {
              name: 'EditarLocalidade',
              params: {
                idProjeto: _vm.idProjeto,
                idLocalidade: props.item.id
              }
            }
          }
        }, [_vm._v("\n          " + _vm._s(props.item.nome) + "\n        ")])], 1) : _c('div', [_vm._v("\n        " + _vm._s(props.item.nome) + "\n      ")])]
      }
    }, {
      key: "item.opcoes",
      fn: function(props) {
        return [(_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('v-btn', {
          attrs: {
            "color": "primary",
            "text": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.excluirLocalidade(props.item.id)
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaLocalidades.length) + " localidades\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('c-card-footer', {
    attrs: {
      "projeto": this.projeto,
      "extensao": this.extensao,
      "proxima": "ArquivosProjeto",
      "editar": "NovaLocalidade",
      "nome_editar": "Nova Localidade",
      "habilitaBotaoGerarPDFAcao": true,
      "habilitaBotaoFinalizarAcao": true
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toLimparLocalidades
    }
  }, [_vm._v("Limpar")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dc6cc78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projeto/projeto-abrangencia-tabela.vue
// module id = 495
// module chunks = 0